import React, { ComponentProps } from 'react';

import { useState } from 'react';
import { useLanguage } from '../../../i18n';
import { LoginOrRegisterModal } from '../../auth/LoginOrRegisterModal';
import Button from '../atoms/button';
import { navigate } from 'gatsby';
import Anchor from '../atoms/anchor';

type LoginOrRegisterButtonProps = {
    type: 'login' | 'register';
    children: React.ReactNode;
    variant: ComponentProps<typeof Button>['variant'] | ComponentProps<typeof Anchor>['variant'];
    size: ComponentProps<typeof Anchor>['size'] | ComponentProps<typeof Button>['size'];
    appearance: 'button' | 'link';
    className?: string;
};

export const LoginOrRegisterButton = ({
    children,
    type,
    variant,
    className,
    size,
    appearance,
}: LoginOrRegisterButtonProps) => {
    let [showLoginModal, setShowLoginModal] = useState(false);
    let language = useLanguage();

    return (
        <div>
            {showLoginModal && (
                <LoginOrRegisterModal
                    initialState={{ type }}
                    doClose={() => {
                        setShowLoginModal(false);

                        // When logging in on the community page, we want to redirect to "thanks for joinint the community"
                        if (window.location.pathname.endsWith('/content/community')) {
                            void navigate(`/${language}/community`);
                        }
                    }}
                />
            )}
            {appearance === 'button' ? (
                <Button
                    as="button"
                    className={className}
                    size={size}
                    variant={variant as ComponentProps<typeof Button>['variant']}
                    onClick={() => {
                        setShowLoginModal(true);
                    }}
                >
                    {children}
                </Button>
            ) : (
                <Anchor
                    as="button"
                    className={className}
                    size={size}
                    variant={variant as ComponentProps<typeof Anchor>['variant']}
                    onClick={() => {
                        setShowLoginModal(true);
                    }}
                >
                    {children}
                </Anchor>
            )}
        </div>
    );
};
